exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "h4 {\n  margin-top: 0px; }\n\n.variant-details {\n  padding-left: 0; }\n\n.variant-image img {\n  width: 100px; }\n\np {\n  margin-bottom: 5px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/fonzi-module/variant/variant.component.scss
// module id = 736
// module chunks = 1